import { ShoppingBag } from "lucide-react";
import type { ModuleSpec } from "../types";

/**
 * botbat-cart launcher entry.
 *
 * Cart is a separate Next.js app under `platform/botbat-cart/` with its own
 * auth, routing, and layout. We don't iframe it — that path requires an
 * embedded mode on cart and an auth-token bridge that doesn't exist yet.
 * Instead, this spec routes to an in-console `/cart` landing page that
 * surfaces the storefront URL, quick-link tiles into specific cart areas,
 * and a primary CTA that opens the cart dashboard in a new tab.
 *
 * Sits next to Calendar in the "Run" group at order 31 so it appears
 * immediately after Calendar (order 30) and before Tickets (order 35).
 */
export const cartSpec: ModuleSpec = {
  id: "cart",
  icon: ShoppingBag,
  i18n: {
    namespace: "modules",
    titleKey: "cart.title",
    descriptionKey: "cart.description",
  },
  nav: {
    path: "/cart",
    group: "run",
    order: 31,
  },
  permission: {
    action: "read",
    subject: "integration",
  },
  meta: {
    status: "active",
    description: "Storefront, products, orders, and customers",
  },
};
